import {
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { fetchGetTermsVersion } from 'api/appApi';
import useIntervalFunctionCall from 'hooks/useIntervalFunctionCall';
import useToggle from 'hooks/useToggle';
import { logout } from 'store/authSlice';

import BottomButtons from '../BottomButtons';
import TermsContent from '../TermsContent';

const localTermsVersion = localStorage.getItem('TermsVersion');

const TermsDialog = () => {
  const dispatch = useDispatch();

  const [isOpen, onOpen, onClose] = useToggle(false);
  const [currentTermsVersion, setCurrentTermsVersion] = useState('');

  const getTermsVersion = async () => {
    const termsVersion = await fetchGetTermsVersion();

    if (termsVersion !== localTermsVersion) {
      onOpen();

      setCurrentTermsVersion(termsVersion);
    }
  };

  useEffect(() => {
    getTermsVersion();
  }, []);

  useIntervalFunctionCall(
    () => {
      getTermsVersion();
    },
    480000, // 8 min
    []
  );

  const handleAccept = () => {
    onClose();

    localStorage.setItem('TermsVersion', currentTermsVersion);
  };

  const handleDecline = () => {
    onClose();

    dispatch(logout());
  };

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} fullWidth maxWidth="sm">
      <DialogTitle id="cancel-dialog-title">Terms & Conditions</DialogTitle>

      <DialogContent>
        <TermsContent
          containerProps={{
            spacing: 2,
            sx: { height: '60vh', overflow: 'scroll' },
          }}
        />
        {!localTermsVersion && (
          <>
            <FormControlLabel
              control={<Checkbox color="primary" defaultChecked />}
              label={
                <Typography variant="subtitle1">
                  Customer agrees to receive emails from Terraboost Media
                </Typography>
              }
              sx={{ mt: 1, span: { padding: '2px' } }}
            />
            <FormControlLabel
              control={<Checkbox color="primary" defaultChecked />}
              label={
                <Typography variant="subtitle1">
                  Customer agrees to receive SMS updates about Terraboost Media
                </Typography>
              }
              sx={{ span: { padding: '2px' } }}
            />
          </>
        )}
        <BottomButtons
          backTitle="Decline"
          submitTitle="Accept"
          onBack={handleDecline}
          onSubmit={handleAccept}
          backColor="error"
        />
      </DialogContent>
    </Dialog>
  );
};

export default TermsDialog;
